import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BookingScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const doctor = location.state || {};
  
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [consultationType, setConsultationType] = useState("Video Call");
  const [sessionMode, setSessionMode] = useState("virtual");

  // Mock data for time slots
  const timeSlots = [
    { time: "11:00 AM", type: "Video Call", mode: "virtual", available: true },
    { time: "11:15 AM", type: "Video Call", mode: "virtual", available: true },
    { time: "11:30 AM", type: "Chat Message", mode: "virtual", available: true },
    { time: "11:30 AM", type: "Video Call", mode: "virtual", available: true },
    { time: "11:35 AM", type: "Video Call", mode: "virtual", available: true },
    { time: "11:45 AM", type: "Chat Message", mode: "virtual", available: true },
    { time: "02:00 PM", type: "In-person Training", mode: "in-person", available: true },
    { time: "02:45 PM", type: "In-person Training", mode: "in-person", available: true },
    { time: "03:30 PM", type: "In-person Training", mode: "in-person", available: true },
  ];

  const visibleSlots = timeSlots.filter((slot) => slot.mode === sessionMode);

  const sessionSummary = consultationType === "In-person Training"
    ? {
        title: "In-person Training with Dr. Samuel Teambo",
        estimate: "45 Minutes Estimate",
        subtitle: "Clinic-based guided training session",
        price: "N5,000",
        unit: "Per training session",
      }
    : {
        title: "Video Call with Dr. Samuel Teambo",
        estimate: "15 Minutes Estimate",
        subtitle: "Online Doctor Visit (Chat available too)",
        price: "N3,000",
        unit: "Per consultation",
      };

  // Mock dates
  const dates = [
    { day: 23, weekday: "Wed" },
    { day: 24, weekday: "Thu" },
    { day: 25, weekday: "Fri" },
    { day: 26, weekday: "Sat" },
    { day: 27, weekday: "Sun" },
    { day: 28, weekday: "Mon" },
    { day: 29, weekday: "Tue" },
  ];

  return (
    <div
      className="container-fluid px-0"
      style={{
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Header */}
      <div
        className="px-3 pt-4 pb-3"
        style={{
          backgroundColor: "white",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <div className="d-flex align-items-center mb-3">
          <button
            className="btn p-0 me-2"
            onClick={() => navigate(-1)}
            style={{ color: "#374151" }}
          >
            <ArrowLeft size={24} />
          </button>
          <h5 className="fw-semibold mb-0" style={{ color: "#111827", fontSize: 18 }}>
            Consultation & Training
          </h5>
        </div>

        {/* Doctor Info Card */}
        <div
          className="rounded-3 p-3 mb-4"
          style={{
            backgroundColor: "#f0f9ff",
            border: "1px solid #bae6fd",
          }}
        >
          <div className="d-flex align-items-start gap-3">
            {/* Doctor Avatar */}
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: 60,
                height: 60,
                backgroundColor: "#dbeafe",
                color: "#1e40af",
                fontSize: 20,
                fontWeight: "bold",
              }}
            >
              ST
            </div>

            {/* Doctor Details */}
            <div className="flex-grow-1">
              <div className="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <h6 className="fw-bold mb-0" style={{ color: "#111827", fontSize: 16 }}>
                    Dr. Samuel Teambo
                  </h6>
                  <p className="mb-1" style={{ color: "#6b7280", fontSize: 14 }}>
                    Cardiologist
                  </p>
                </div>
                <span
                  className="d-flex align-items-center gap-1 px-2 py-1 rounded-pill"
                  style={{
                    backgroundColor: "#dcfce7",
                    color: "#166534",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  <span style={{ fontSize: 8 }}>●</span> Online Now
                </span>
              </div>

              {/* Doctor Stats */}
              <div className="d-flex gap-3 mb-2" style={{ fontSize: 13, color: "#4b5563" }}>
                <span>8+ years</span>
                <span>English</span>
                <span>MBBS, U of Lagos</span>
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-2">
                <button
                  className="btn flex-fill rounded-pill py-2"
                  style={{
                    backgroundColor: "#e5e7eb",
                    color: "#374151",
                    fontSize: 14,
                    fontWeight: 500,
                    border: "none",
                  }}
                >
                  Chat
                </button>
                <button
                  className="btn flex-fill rounded-pill py-2"
                  style={{
                    backgroundColor: "#4f46e5",
                    color: "white",
                    fontSize: 14,
                    fontWeight: 500,
                    border: "none",
                  }}
                >
                  Video Call
                </button>
              </div>
            </div>
          </div>

          {/* Past Consultations */}
          <div className="mt-3 pt-3 border-top">
            <h6 className="fw-semibold mb-2" style={{ fontSize: 14, color: "#111827" }}>
              Past Consultations
            </h6>
            <div className="d-flex justify-content-between">
              <div className="text-center">
                <div style={{ fontSize: 20, fontWeight: "bold", color: "#111827" }}>78</div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>High Blood Pressure</div>
              </div>
              <div className="text-center">
                <div style={{ fontSize: 20, fontWeight: "bold", color: "#111827" }}>46</div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>Chest Pain</div>
              </div>
              <div className="text-center">
                <div style={{ fontSize: 20, fontWeight: "bold", color: "#111827" }}>32</div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>Heart Palpitations</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-3 pt-4">
        <h6 className="fw-semibold mb-3" style={{ color: "#111827", fontSize: 16 }}>
          Select a time for your consultation
        </h6>

        <div className="d-flex gap-2 mb-3">
          <button
            onClick={() => {
              setSessionMode("virtual");
              setSelectedTime(null);
              setConsultationType("Video Call");
            }}
            className="btn rounded-pill"
            style={{
              backgroundColor: sessionMode === "virtual" ? "#4f46e5" : "#eef2ff",
              color: sessionMode === "virtual" ? "white" : "#3730a3",
              fontSize: 13,
              fontWeight: 600,
              border: "none",
            }}
          >
            Virtual Consultation
          </button>

          <button
            onClick={() => {
              setSessionMode("in-person");
              setSelectedTime(null);
              setConsultationType("In-person Training");
            }}
            className="btn rounded-pill"
            style={{
              backgroundColor: sessionMode === "in-person" ? "#4f46e5" : "#eef2ff",
              color: sessionMode === "in-person" ? "white" : "#3730a3",
              fontSize: 13,
              fontWeight: 600,
              border: "none",
            }}
          >
            In-person Training
          </button>
        </div>

        {/* Date Selector */}
        <div className="d-flex justify-content-between mb-4 overflow-auto" style={{ gap: 12 }}>
          {dates.map((date, index) => (
            <button
              key={index}
              onClick={() => setSelectedDate(date.day)}
              className={`d-flex flex-column align-items-center justify-content-center rounded-3 py-3 ${
                selectedDate === date.day ? "selected" : ""
              }`}
              style={{
                minWidth: 60,
                backgroundColor: selectedDate === date.day ? "#4f46e5" : "white",
                border: selectedDate === date.day ? "none" : "1px solid #e5e7eb",
                transition: "all 0.2s",
              }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  color: selectedDate === date.day ? "white" : "#111827",
                }}
              >
                {date.day}
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: selectedDate === date.day ? "white" : "#6b7280",
                }}
              >
                {date.weekday}
              </div>
            </button>
          ))}
        </div>

        {/* Time Slots */}
        <div className="mb-5">
          {visibleSlots.map((slot, index) => (
            <button
              key={index}
              onClick={() => {
                setSelectedTime(slot.time);
                setConsultationType(slot.type);
              }}
              className={`d-flex justify-content-between align-items-center w-100 rounded-3 p-3 mb-2 ${
                selectedTime === slot.time && consultationType === slot.type ? "selected" : ""
              }`}
              style={{
                backgroundColor: selectedTime === slot.time && consultationType === slot.type ? "#eef2ff" : "white",
                border: selectedTime === slot.time && consultationType === slot.type ? "1px solid #4f46e5" : "1px solid #e5e7eb",
                transition: "all 0.2s",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 40,
                    height: 40,
                    backgroundColor: slot.type === "Video Call" ? "#dbeafe" : slot.type === "Chat Message" ? "#f0f9ff" : "#fef3c7",
                    color: slot.type === "Video Call" ? "#1e40af" : slot.type === "Chat Message" ? "#0369a1" : "#92400e",
                  }}
                >
                  {slot.type === "Video Call" ? "📹" : slot.type === "Chat Message" ? "💬" : "🏥"}
                </div>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: 16, fontWeight: 500, color: "#111827" }}>
                    {slot.type}
                  </div>
                  <div style={{ fontSize: 14, color: "#6b7280" }}>
                    with Dr. Samuel Teambo
                  </div>
                </div>
              </div>
              <div style={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>
                {slot.time}
              </div>
            </button>
          ))}
        </div>

        {/* Meeting Info */}
        <div
          className="rounded-3 p-3 mb-3"
          style={{
            backgroundColor: "#f8fafc",
            border: "1px solid #e5e7eb",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span style={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>
              {sessionSummary.title}
            </span>
            <span style={{ fontSize: 14, color: "#6b7280" }}>{sessionSummary.estimate}</span>
          </div>
          <div style={{ fontSize: 13, color: "#6b7280" }}>
            {sessionSummary.subtitle}
          </div>
        </div>

        {/* Payment Section */}
        <div
          className="rounded-3 p-3 mb-4"
          style={{
            backgroundColor: "#f8fafc",
            border: "1px solid #e5e7eb",
          }}
        >
          <h6 className="fw-semibold mb-2" style={{ fontSize: 14, color: "#111827" }}>
            Payment & Insurance
          </h6>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div style={{ fontSize: 24, fontWeight: "bold", color: "#111827" }}>
                {sessionSummary.price}
              </div>
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                {sessionSummary.unit}
              </div>
            </div>
            <button
              className="btn rounded-pill px-4 py-3"
              style={{
                backgroundColor: "#4f46e5",
                color: "white",
                fontSize: 16,
                fontWeight: 600,
              }}
              onClick={() => navigate("/payment-confirmation")}
            >
              Confirm & Book &gt;
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div
        className="fixed-bottom d-flex justify-content-around align-items-center py-3"
        style={{
          backgroundColor: "white",
          borderTop: "1px solid #e5e7eb",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        {["Home", "Marketplace", "Wallet", "Profile"].map((item, index) => (
          <button
            key={index}
            className="btn d-flex flex-column align-items-center"
            style={{
              color: item === "Profile" ? "#4f46e5" : "#9ca3af",
              fontSize: 12,
            }}
          >
            <div style={{ fontSize: 20, marginBottom: 2 }}>
              {item === "Home" && "🏠"}
              {item === "Marketplace" && "🛒"}
              {item === "Wallet" && "💰"}
              {item === "Profile" && "👤"}
            </div>
            <span>{item}</span>
          </button>
        ))}
      </div>
    </div>
  );
}